module.exports = __webpack_public_path__ + "img/try3.1e1fe22e.png";